import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine } from "./Reveal";
import { scrollTo, bookService } from "./Nav";

export const Hero = () => {
    return (
        <section id="top" data-testid="hero-section" className="relative pt-28 md:pt-40 pb-20 md:pb-32 overflow-hidden">
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1, duration: 0.8 }}
                    data-testid="hero-kicker"
                    className="flex items-center gap-3 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/60"
                >
                    <span className="h-px w-10 bg-worx inline-block" />
                    Consulting WorX — Websites, Web Apps & AI Systems · Palm Springs, FL
                </motion.p>

                <h1 className="mt-6 font-display font-semibold leading-[0.95] tracking-tighter text-[14vw] sm:text-7xl lg:text-8xl xl:text-9xl" data-testid="hero-headline">
                    <MaskedLine delay={0.2}>Websites & apps,</MaskedLine>
                    <MaskedLine delay={0.38}>
                        <span className="text-worx">built for you.</span>
                    </MaskedLine>
                </h1>

                <div className="mt-10 grid md:grid-cols-2 gap-8 items-end">
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.65, duration: 0.8 }}
                        data-testid="hero-sub"
                        className="text-base md:text-lg text-ink/70 max-w-md leading-relaxed"
                    >
                        Custom websites, web applications, and CRM systems for your business — designed,
                        built, and launched by a developer who speaks plain English. Every project starts
                        with a free discovery call, in person or on Google Meet. Rather learn it yourself?
                        One-on-one AI classes too.
                    </motion.p>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.75, duration: 0.8 }}
                        className="flex flex-wrap md:justify-end gap-3"
                    >
                        <a
                            href="#booking"
                            onClick={bookService("web-dev")}
                            data-testid="hero-book-btn"
                            className="inline-flex items-center gap-2 bg-worx text-white px-7 py-3.5 font-medium hover:bg-ink transition-colors duration-200"
                        >
                            Book a free dev consult <ArrowUpRight size={16} />
                        </a>
                        <a
                            href="#services"
                            onClick={scrollTo("#services")}
                            data-testid="hero-services-btn"
                            className="inline-flex items-center gap-2 border border-ink px-7 py-3.5 font-medium hover:bg-ink hover:text-paper transition-colors duration-200"
                        >
                            Explore services
                        </a>
                    </motion.div>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1, duration: 0.7 }}
                    data-testid="hero-price-badge"
                    className="mt-14 md:mt-20 inline-block max-w-full bg-ink text-paper px-6 py-4 font-display text-sm md:text-base tracking-tight leading-snug"
                >
                    <span className="block">Free discovery call — websites, apps & CRMs</span>
                    <span className="block text-paper/60">1-on-1 AI classes from $95/hr prepaid</span>
                </motion.div>
            </div>
        </section>
    );
};
